import { defaultTheme } from '../../../../../../utils/defaultTheme';

export const getChartAreasData = (limits, dataRanges, colors) => {
    const { meanX, maxX, minY, meanY } = dataRanges;
    return [
        {
            x: limits.left,
            y: limits.top,
            width: meanX - limits.left,
            height: meanY - limits.top,
            label: 'Good value',
            color: colors.GOOD_VALUE,
        },
        {
            x: meanX,
            y: limits.top,
            width: maxX - meanX,
            height: meanY - limits.top,
            label: 'Premium',
            color: colors.PREMIUM,
        },
        {
            x: limits.left,
            y: meanY,
            width: meanX - limits.left,
            height: minY - meanY,
            label: 'Low Cost',
            color: colors.LOW_COST,
        },
        {
            x: meanX,
            y: meanY,
            width: maxX - meanX,
            height: minY - meanY,
            label: 'Poor value',
            color: colors.POOR_VALUE,
        },
    ];
};

export const getMappingMainAxisLines = (limits, dataRanges) => {
    const { maxX, minY, maxY } = dataRanges;
    return [
        {
            lines: [
                [limits.left, minY],
                [limits.left, limits.top - 10],
            ],
            text: {
                text: 'Quality of Offer',
                x: limits.left - 10,
                y: maxY + 96,
                rotate: '-90deg',
            },
        },
        {
            lines: [
                [limits.left, minY],
                [maxX + 10, dataRanges.minY],
            ],
            text: {
                text: 'Price',
                x: maxX - 31,
                y: minY + 19,
                rotate: '0deg',
            },
        },
    ];
};

export const getMappingLabelsData = (limits, dataRanges, colors, unScaledData) => {
    const { meanX, maxX, minY, meanY } = dataRanges;
    return [
        {
            text: 'Good Value for Money',
            x: 0,
            y: (meanY + 35) / 2,
            height: 70,
            width: limits.left,
            color: colors.GOOD_VALUE,
            textColor: colors.GOOD_VALUE_TEXT,
            fontSize: '14px',
            tooltip: null,
        },
        {
            text: 'Low Cost',
            x: 0,
            y: (minY + meanY - 35) / 2,
            height: 70,
            width: limits.left,
            color: colors.LOW_COST,
            textColor: colors.LOW_COST_TEXT,
            fontSize: '14px',
            tooltip: null,
        },
        {
            text: 'Poor Value For Money',
            x: maxX,
            y: (minY + meanY - 35) / 2,
            height: 70,
            width: limits.left,
            color: colors.POOR_VALUE,
            textColor: colors.POOR_VALUE_TEXT,
            fontSize: '14px',
            tooltip: null,
        },
        {
            text: 'Premium',
            x: maxX,
            y: (meanY + 50) / 2,
            height: 48,
            width: limits.left,
            color: colors.PREMIUM,
            textColor: colors.PREMIUM_TEXT,
            fontSize: '14px',
            tooltip: null,
        },
        {
            text: 'Mean Score for price',
            x: meanX - 100,
            y: (limits.top - 2) / 2 + 1,
            height: limits.top / 2,
            width: 200,
            color: defaultTheme.white.ff,
            textColor: defaultTheme.blue['800'],
            fontSize: '13px',
            tooltip: {
                xPos: meanX + 6,
                yPos: (limits.top - 2) / 2 + 47,
                x: unScaledData.xAxisMean,
                paddindValue: 30,
                lineClass: '.mean-y-line',
                triangleId: '#Triangle3',
            },
        },
        {
            text: 'Mean Score for quality of offer',
            x: maxX,
            y: meanY - 27,
            height: 48,
            width: limits.left,
            color: defaultTheme.white.ff,
            textColor: defaultTheme.blue['800'],
            fontSize: '13px',
            tooltip: {
                xPos: maxX,
                yPos: meanY,
                x: unScaledData.yAxisMean,
                paddindValue: 30,
                lineClass: '.mean-x-line',
                triangleId: '#Triangle2',
            },
        },
    ];
};

export const getLineLength = (x1, x2, y1, y2) => {
    const a = parseFloat(x1) - parseFloat(x2);
    const b = parseFloat(y1) - parseFloat(y2);

    return Math.sqrt(a * a + b * b);
};

export const dataByYear = {
    2023: {
        sectionID: 1,
        sectionLabel: 'OVERALL VALUE FOR MONEY',
        sectionOrder: 1,
        scope: null,
        source: null,
        currency: null,
        sectionType: 'Benchmark',
        kpis: null,
        tables: null,
        benchmark: {
            countryId: 108,
            countryName: 'France - Direct Assurance',
            mainXAxisMin: 2.56085324440873,
            mainXAxisMax: 3.89722955315117,
            mainYAxisMin: 2.7625372190827497,
            mainYAxisMax: 3.37573321552121,
            xAxisMean: 3.222510641266396,
            yAxisMean: 3.13235601988461,
            points: [
                {
                    cell: 36,
                    productName: 'Allianz',
                    xValue: 3.55157566293347,
                    yValue: 3.24798935841002,
                    imageUrl: null,
                },
                {
                    cell: 62,
                    productName: 'BoursoBank/Boursorama',
                    xValue: 2.66085324440873,
                    yValue: 3.0869174167278,
                    imageUrl: null,
                },
                {
                    cell: 9004,
                    productName: 'BNP Paribas / Cardif / Natio Vie',
                    xValue: 3.60552037554869,
                    yValue: 3.04184666864368,
                    imageUrl: null,
                },
                {
                    cell: 181,
                    productName: 'MMA',
                    xValue: 3.19991708022561,
                    yValue: 3.14663171859919,
                    imageUrl: null,
                },
                {
                    cell: 145,
                    productName: 'La Banque Postale',
                    xValue: 3.0643658128791,
                    yValue: 2.86253721908275,
                    imageUrl: null,
                },
                {
                    cell: 96,
                    productName: 'Direct Assurance',
                    xValue: 2.75979806334511,
                    yValue: 2.90104633369141,
                    imageUrl:
                        'https://dbhubbkkm6uku.cloudfront.net/visuals/DirectAssurance_Logo.png?Expires=1743583096&Signature=gfbXmgSDVslmpGlNqUADKpT0EE~mVulU237qvtBsYsnP1ormZJtljZVHaOl9y1nIlOizwKUNDzTCAcTYbJFrRwnUKoODLSFqDJyGAgjcb~ecep08ClJnitOI~S~OezCD~jpOdvW8k6YZSbcIHl4KeWBoeU67y1QU75NT-D6xn~qQltTP2QjE7Zm7DoKJLMSCieeZuTZaCR0onxT3UFhY5bxDCs8bcGJbfmXsR~Z~5wtXJ3mszo0AW4uHH7yGDRtVudHXcnokZ87uuekyiA~eBVTcR6oOLskTsI6d9pw7nPnV6Qpz5iIjqekGveRo8VcVDNPYvG6v-a6gxh9sBeoH-Q__&Key-Pair-Id=K23EPIM3SQEY3Y',
                },
                {
                    cell: 9006,
                    productName: 'Crédit Mutuel',
                    xValue: 3.14798118365742,
                    yValue: 3.2382237677198,
                    imageUrl: null,
                },
                {
                    cell: 9001,
                    productName: 'AXA',
                    xValue: 3.52960068886822,
                    yValue: 3.20966498860169,
                    imageUrl: null,
                },
                {
                    cell: 164,
                    productName: 'MAIF',
                    xValue: 3.09663141931166,
                    yValue: 3.27573321552121,
                    imageUrl: null,
                },
                {
                    cell: 67,
                    productName: "Caisse d'Epargne Ecureuil",
                    xValue: 3.27747280976514,
                    yValue: 2.9979105799287,
                    imageUrl: null,
                },
                {
                    cell: 248,
                    productName: 'Swiss Life',
                    xValue: 3.79722955315117,
                    yValue: 3.26022790819668,
                    imageUrl: null,
                },
                {
                    cell: 161,
                    productName: 'MACIF',
                    xValue: 3.05029295533053,
                    yValue: 3.2401062638209,
                    imageUrl: null,
                },
                {
                    cell: 160,
                    productName: 'MAAF',
                    xValue: 3.06109720326517,
                    yValue: 3.19452395200432,
                    imageUrl: null,
                },
                {
                    cell: 123,
                    productName: 'Groupama',
                    xValue: 3.27184516653327,
                    yValue: 3.14130309152809,
                    imageUrl: null,
                },
                {
                    cell: 9005,
                    productName: 'Crédit Agricole / Pacifica / Predica',
                    xValue: 3.26347839977266,
                    yValue: 3.14067781579292,
                    imageUrl: null,
                },
            ],
            benchmarkLabel: 'FY  2024',
            nrRespondents: 48286,
        },
        infoText: null,
    },
    2024: {
        sectionID: 1,
        sectionLabel: 'OVERALL VALUE FOR MONEY',
        sectionOrder: 1,
        scope: null,
        source: null,
        currency: null,
        sectionType: 'Benchmark',
        kpis: null,
        tables: null,
        benchmark: {
            countryId: 108,
            countryName: 'France - Direct Assurance',
            mainXAxisMin: 2.56884309550892,
            mainXAxisMax: 3.90460730823247,
            mainYAxisMin: 2.74682089269664,
            mainYAxisMax: 3.37757603700059,
            xAxisMean: 3.2198964594182553,
            yAxisMean: 3.1327359936602277,
            points: [
                {
                    cell: 145,
                    productName: 'La Banque Postale',
                    xValue: 3.06011880669277,
                    yValue: 2.84682089269664,
                    imageUrl: null,
                },
                {
                    cell: 161,
                    productName: 'MACIF',
                    xValue: 3.04464764656559,
                    yValue: 3.23431848949384,
                    imageUrl: null,
                },
                {
                    cell: 96,
                    productName: 'Direct Assurance',
                    xValue: 2.74845910508033,
                    yValue: 2.89300000339292,
                    imageUrl:
                        'https://dbhubbkkm6uku.cloudfront.net/visuals/DirectAssurance_Logo.png?Expires=1734014796&Signature=FXI63yzejhEakeZlmdMDPusGO0XyZgj9R6RmYUz8kNN5LiXVKXEB2TzqhEei~ATzFJgGkgCzsCxk0BKp1pJfENOM7ZJ2K7v6AwH4KplRQGQefZg0Dk6C54p8vl2egcN8kw3iGz-moIl6IoaYdUl5F4GWWQLSkpm5jD8QnMkEBhsG9CsL4AF35qi0dZJBQwCs0VRMUKXJS-e4qgtwELePW4OeiUxBn-6kJcFJqhOCVvJgvDoKgSYiJ6zxRbcnP~ygO8-uHu6p3hkzMZUwy3H~1GBr2sVpj~icPDhfTL0B-CT4cu7qiQvjwpv1sptQoFCmHC1pdI0S8edQnmlbaXbaiQ__&Key-Pair-Id=K23EPIM3SQEY3Y',
                },
                {
                    cell: 67,
                    productName: "Caisse d'Epargne Ecureuil",
                    xValue: 3.26874157275498,
                    yValue: 3.00500319976875,
                    imageUrl: null,
                },
                {
                    cell: 248,
                    productName: 'Swiss Life',
                    xValue: 3.80460730823247,
                    yValue: 3.26652201616416,
                    imageUrl: null,
                },
                {
                    cell: 123,
                    productName: 'Groupama',
                    xValue: 3.2762909004219,
                    yValue: 3.14013798369264,
                    imageUrl: null,
                },
                {
                    cell: 9004,
                    productName: 'BNP Paribas / Cardif / Natio Vie',
                    xValue: 3.60836070728295,
                    yValue: 3.04726330647135,
                    imageUrl: null,
                },
                {
                    cell: 9006,
                    productName: 'Crédit Mutuel',
                    xValue: 3.13390798472988,
                    yValue: 3.25156374450435,
                    imageUrl: null,
                },
                {
                    cell: 9001,
                    productName: 'AXA',
                    xValue: 3.5295265796831,
                    yValue: 3.20725280833298,
                    imageUrl: null,
                },
                {
                    cell: 9005,
                    productName: 'Crédit Agricole / Pacifica / Predica',
                    xValue: 3.25171945193027,
                    yValue: 3.1335856876669,
                    imageUrl: null,
                },
                {
                    cell: 181,
                    productName: 'MMA',
                    xValue: 3.20348170034239,
                    yValue: 3.1461329319405,
                    imageUrl: null,
                },
                {
                    cell: 36,
                    productName: 'Allianz',
                    xValue: 3.5581721630734,
                    yValue: 3.246797664205,
                    imageUrl: null,
                },
                {
                    cell: 62,
                    productName: 'BoursoBank/Boursorama',
                    xValue: 2.66884309550892,
                    yValue: 3.08780652708072,
                    imageUrl: null,
                },
                {
                    cell: 164,
                    productName: 'MAIF',
                    xValue: 3.08710402749182,
                    yValue: 3.27757603700059,
                    imageUrl: null,
                },
                {
                    cell: 160,
                    productName: 'MAAF',
                    xValue: 3.05446584148306,
                    yValue: 3.20725861249207,
                    imageUrl: null,
                },
            ],
            benchmarkLabel: 'YTD  2024',
            nrRespondents: 35719,
        },
        infoText: null,
    },
};

export const mockdata = [
    {
        name: 'Price perception YTD  2024',
        respondents: 42081,
        chart: [
            {
                group: 'More expensive',
                PerceptionaboutAXA: [57, null],
                Perceptionaboutallbrands: [25, null],
            },
            {
                group: 'Averagely priced',
                PerceptionaboutAXA: [39, null],
                Perceptionaboutallbrands: [45, null],
            },
            {
                group: 'Less expensive',
                PerceptionaboutAXA: [3, null],
                Perceptionaboutallbrands: [33, null],
            },
        ],
        colors: [
            {
                color: '#FAF1FF',
                name: 'Perception about AXA',
            },
            {
                color: '#E8F9ED',
                name: 'Perception about all brands',
            },
        ],
    },
    {
        name: 'Quality of offer perception YTD  2024',
        respondents: 42081,
        chart: [
            {
                group: 'Above market average',
                PerceptionaboutAXA: [27, null],
                Perceptionaboutallbrands: [29, null],
            },
            {
                group: 'Average',
                PerceptionaboutAXA: [49, null],
                Perceptionaboutallbrands: [59, null],
            },
            {
                group: 'Below market average',
                PerceptionaboutAXA: [41, null],
                Perceptionaboutallbrands: [13, null],
            },
        ],
        colors: [
            {
                color: 'red',
                name: 'Perception about AXA',
            },
            {
                color: 'green',
                name: 'Perception about all brands',
            },
        ],
    },
];
